
/**
 * `Coordinates` type.
 */

type Coordinates = {
  lat: number,
  lng: number
};

/**
 * Export `mapUrlResolver`.
 */

export function mapUrlResolver(coordinates: Coordinates) {
  return `http://www.google.com/maps/place/${coordinates.lat},${coordinates.lng}/@${coordinates.lat},${coordinates.lng},16z`;
}
